<template>
<div class="profit-edit-drawer">
  <el-drawer title="利润预估" :visible.sync="drawer" :direction="direction" :before-close="closeDrawer" :modal="showMark" size="100%">
    <div class="drawer-form">
      <div class="box" style="overflow-x: none">
        <el-form ref="profitForm" :rules="rules" :model="orderProfit" :inline="true" label-position="top">
          <el-form-item label="收入总额" prop="income_fee">
            <el-input v-model="orderProfit.income_fee" @input="profitChange"></el-input>
          </el-form-item>
          <el-form-item label="收入总额备注">
            <el-input v-model="orderProfit.income_fee_remark"></el-input>
          </el-form-item>
          <el-form-item label="应付酒店" prop="pay_hotel_fee">
            <el-input v-model="orderProfit.pay_hotel_fee" @input="profitChange"></el-input>
          </el-form-item>
          <el-form-item label="应付酒店备注">
            <el-input v-model="orderProfit.pay_hotel_fee_remark"></el-input>
          </el-form-item>
          <el-form-item label="平台渠道费用" prop="source_fee">
            <el-input v-model="orderProfit.source_fee" @input="profitChange"></el-input>
          </el-form-item>
          <el-form-item label="平台渠道备注">
            <el-input v-model="orderProfit.source_fee_remark"></el-input>
          </el-form-item>
          <el-form-item label="个人渠道费用" prop="person_source_fee">
            <el-input v-model="orderProfit.person_source_fee" @input="profitChange"></el-input>
          </el-form-item>
          <el-form-item label="个人渠道备注">
            <el-input v-model="orderProfit.person_source_fee_remark"></el-input>
          </el-form-item>
          <el-form-item label="酒水成本" prop="wine_cost">
            <el-input v-model="orderProfit.wine_cost" @input="profitChange"></el-input>
          </el-form-item>
          <el-form-item label="酒水成本备注">
            <el-input v-model="orderProfit.wine_cost_remark"></el-input>
          </el-form-item>
          <el-form-item label="赠送成本" prop="free_cost">
            <el-input v-model="orderProfit.free_cost" @input="profitChange"></el-input>
          </el-form-item>
          <el-form-item label="赠送成本备注">
            <el-input v-model="orderProfit.free_cost_remark"></el-input>
          </el-form-item>
          <el-form-item label="婚庆签单额" prop="wedding_cost">
            <el-input v-model="orderProfit.wedding_cost" @input="profitChange"></el-input>
          </el-form-item>
          <el-form-item label="婚庆签单额备注">
            <el-input v-model="orderProfit.wedding_cost_remark"></el-input>
          </el-form-item>
          <el-form-item label="婚宴净利" prop="banquet_profit">
            <el-input readonly v-model="orderProfit.banquet_profit" @input="profitChange"></el-input>
          </el-form-item>
          <el-form-item label="婚宴净利备注">
            <el-input v-model="orderProfit.banquet_profit_remark"></el-input>
          </el-form-item>
        </el-form>
        <auditProcess :process="confirmList"></auditProcess>

        <!-- 修改记录 -->
        <div v-if="recordList.length > 0">
          <el-divider content-position="center">修改记录</el-divider>
          <record ref="record" :recordList="recordList" :fields="fields"></record>
        </div>

        <!-- 审核流程 -->
        <!-- <div class="confirm-box" v-if="confirmList.length > 0">
                    <el-divider content-position="center">审核流程</el-divider>
                    <step ref="step" :confirmList="confirmList"></step>
                </div> -->
        <div class="drawer__footer">
          <el-button type="primary" @click="onSubmit('profitForm')">确定编辑</el-button>
          <el-button type="primary" v-if="confirm.status != undefined && confirm.status == 0" @click="confirmSubmit('profitForm')">审核通过</el-button>
          <el-button @click="resetForm('profitForm')">取消</el-button>
        </div>
      </div>
    </div>
  </el-drawer>
</div>
</template>

<script>
import step from '@/components/step/step.vue'; // 老版审核流程
// 所有修改记录
import record from '@/components/record/order';

import auditProcess from './components/auditProcess.vue';
export default {
  components: {
    auditProcess,
    step,
    record
  },
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      showMark: true,
      // 修改记录
      recordList: [],
      orderProfit: {
        source_fee: 0,
        source_fee_remark: '',
        person_source_fee: 0,
        person_source_fee_remark: '',
        wine_cost: 0,
        wedding_cost: 0,
        banquet_profit: 0,
        free_cost: 0,
        wine_cost_remark: '',
        wedding_cost_remark: '',
        banquet_profit_remark: '',
        free_cost_remark: '',
        pay_hotel_fee: 0,
        pay_hotel_fee_remark: '',
        income_fee: 0,
        income_fee_remark: ''
      },
      profit_id: 0,
      order_id: 0,
      rules: {
        source_fee: [{
          required: true,
          trigger: 'blur'
        }],
        person_source_fee: [{
          required: true,
          trigger: 'blur'
        }],
        wine_cost: [{
          required: true,
          trigger: 'blur'
        }],
        wedding_cost: [{
          required: true,
          trigger: 'blur'
        }],
        banquet_profit: [{
          required: true,
          trigger: 'blur'
        }],
        free_cost: [{
          required: true,
          trigger: 'blur'
        }],
        pay_hotel_fee: [{
          required: true,
          trigger: 'blur'
        }],
        income_fee: [{
          required: true,
          trigger: 'blur'
        }]
      },
      confirmList: [],
      process: [],
      isEdit: false,
      confirm: {}
    };
  },
  created() {
    let that = this;
    let path = this.$route.path;
    if (path == '/confirm/confirm/profit') {
      that.showMark = false;
    }
  },
  mounted() {},
  methods: {
    handleShow(data) {
      if (data.order) {
        this.order_id = data.order.id;
        this.profit_id = data.profit.id;
      } else {
        this.order_id = data.id;
        this.profit_id = data.profit.id;
      }
      this.drawer = true;
      if (data.profit.id) {
        this.getOrderInfo();
      }
      // this.getprocess();
    },
    // 关闭
    closeDrawer() {
      this.$refs['profitForm'].resetFields();
      this.orderProfit = {
        source_fee: 0,
        source_fee_remark: '',
        person_source_fee: 0,
        person_source_fee_remark: '',
        wine_cost: 0,
        wedding_cost: 0,
        banquet_profit: 0,
        free_cost: 0,
        wine_cost_remark: '',
        wedding_cost_remark: '',
        banquet_profit_remark: '',
        free_cost_remark: '',
        pay_hotel_fee: 0,
        pay_hotel_fee_remark: '',
        income_fee: 0,
        income_fee_remark: ''
      };
      this.profit_id = 0;
      this.order_id = 0;
      this.drawer = false;
      this.$emit('closeShowOrderDrawer');
    },
    // 获取订单信息
    getOrderInfo() {
      let url = '/api/order.profit/read';
      let query = {
        id: this.profit_id
      };
      this.$post(url, query).then((res) => {
        if (res.code == 200) {
          this.orderProfit = res.data.row.length == 0 ? {} : res.data.row;
          this.drawer = true;
          this.confirm = res.data.confirm;
          this.confirmList = res.data.confirmList;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 利润发生变化
    profitChange() {
      let that = this;
      that.orderProfit.banquet_profit = (
        parseFloat(that.orderProfit.income_fee) -
        parseFloat(that.orderProfit.pay_hotel_fee ? that.orderProfit.pay_hotel_fee : 0) -
        parseFloat(that.orderProfit.source_fee) -
        parseFloat(that.orderProfit.person_source_fee) -
        parseFloat(that.orderProfit.wine_cost) -
        parseFloat(that.orderProfit.free_cost) -
        parseFloat(that.orderProfit.wedding_cost)
      ).toFixed(2);
    },
    onSubmit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          // /api/order.profit/save
          ///api/order.profit/doCreate
          if (that.profit_id > 0) {
            let url = '/api/order.profit/save';
            let query = that.orderProfit;
            that.$post(url, query).then((res) => {
              if (res.code == 200) {
                that.$message({
                  message: res.msg,
                  type: 'success'
                });
                that.drawer = false;
                that.$emit('getData');
                that.closeDrawer();
              } else {
                that.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            });
          } else {
            let url = '/api/order.profit/doCreate';
            let query = Object.assign({
              order_id: that.order_id
            }, {
              orderProfit: that.orderProfit
            });
            this.$post(url, query).then((res) => {
              if (res.code == 200) {
                that.$message({
                  message: res.msg,
                  type: 'success'
                });
                that.drawer = false;
                that.$emit('getData');
                that.closeDrawer();
              } else {
                that.$message({
                  message: res.msg,
                  type: 'error'
                });
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    confirmSubmit(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          let url = '/api/order.confirm/accept';
          let query = {
            id: that.confirm.id
          };
          that.$post(url, query).then((res) => {
            if (res.code == 200) {
              that.$message.success(res.msg);
              that.drawer = false;
              that.$emit('getData');
              that.closeDrawer();
            } else {
              that.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.drawer = false;
    }
    // getprocess() {
    //     let url = '/api/order.profit/create';
    //     let query = { order_id: this.order_id };
    //     this.$post(url, query).then((res) => {
    //         if (res.code == 200) {
    //             this.confirmList = res.data.confirmList;
    //         }
    //     });
    // }
  }
};
</script>

<style lang="less">
@import url('@/assets/css/drawer.less');

.profit-edit-drawer .el-drawer__wrapper {
  left: 62%;
}

.profit-edit-drawer .box {
  padding-top: 30px;
}

.profit-edit-drawer .title_input {
  display: flex;
}

.profit-edit-drawer .title_input span {
  font-size: 14px;
}

.profit-edit-drawer .drawer__footer {
  position: sticky;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background-color: #ffffff;
  z-index: 19;
  height: 44px;
  line-height: 44px;
}
</style>
